var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.171 3.12187C16.7973 3.23531 17.1601 4.13061 16.9801 5.12155C16.801 6.11248 16.1485 6.825 15.5223 6.71155C14.896 6.5981 14.5341 5.7028 14.7132 4.71187C14.8923 3.72 15.5457 3.00842 16.171 3.12187Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5207 3.78378C13.9951 3.8316 14.3195 4.47004 14.2435 5.20785C14.1685 5.94659 13.7223 6.5063 13.2479 6.45753C12.7735 6.40878 12.4492 5.77127 12.5251 5.03253C12.6001 4.29472 13.0454 3.73504 13.5207 3.78378Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4723 4.18675C12.4595 4.28706 12.2261 6.57926 11.2389 6.47894C10.2526 6.37768 10.4861 4.08643 11.4723 4.18675Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4513 6.11347C10.517 7.32753 9.36667 7.38941 9.30103 6.17534C9.2354 4.96128 10.3857 4.89941 10.4513 6.11347Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22782 6.93282C9.28313 7.95563 8.27627 8.01002 8.22095 6.9872C8.16563 5.96532 9.1725 5.91094 9.22782 6.93282Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3088 8.56772C16.2366 7.84772 15.3966 7.19991 14.2688 7.05553C14.1731 7.05553 14.101 7.03115 14.0044 7.03115C13.9322 7.00678 13.8366 7.00678 13.74 6.98334C13.5 6.95897 13.26 6.95897 13.0444 6.95897C9.75663 6.76678 8.43663 9.59897 8.38887 10.3434C8.17324 11.1356 8.60449 13.2234 8.60449 13.2234C8.60449 13.2234 10.0679 16.679 9.9723 17.399C9.87667 18.119 9.92449 18.6946 10.0201 19.1746C10.1157 19.8702 10.5001 20.4946 11.0757 20.879L11.1245 20.9277C11.3401 21.0721 11.5089 21.1199 11.5089 21.1199C11.7245 21.2155 11.9645 21.2643 12.2289 21.2877C13.5489 21.3833 14.7011 20.3521 14.7966 19.0077C14.8444 18.2633 14.5566 17.5677 14.0522 17.0877C11.9166 14.3032 13.38 12.6477 13.38 12.6477C16.2132 10.9677 16.5488 9.47996 16.3088 8.56772Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoot);
export default __webpack_public_path__ + "static/media/foot.3467a9e644a9964ecb886f8706a4c1b0.svg";
export { ForwardRef as ReactComponent };